module.exports = require("react-to-print");